// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_qMR","cls2":"LoggedOutDiscoveryPage-cls2_p1N LoggedOutDiscoveryPage-cls1_qMR"};